module.exports = __webpack_public_path__ + "static/media/03.919db585.mp3";